import React, { FC, useRef, useState } from 'react';
import CheckBox from 'src/components/atoms/CheckBox';
import { familyInitDataStore } from 'src/store/familyInfo';
import '../style.scss';

interface Props {}
const FamilyDescription: FC<Props> = () => {
  const checkTypeEvt = () => {};
  const familyInitResult = familyInitDataStore((state: any) => state.result);
  const familyInitBind = familyInitDataStore((state: any) => state.bind);
  const checkClickEvt = (e: any, status: string, field?: string) => {
    if (field) {
      const vType = status === 'on' ? false : true;
      familyInitResult[field] = vType;
      familyInitBind(familyInitResult);
    }
  };

  return (
    <div className="_creditcard_add_info_description">
      <div className="_grid">
        <div className="_label">
          <div className="_row">
            <div className="_col _col_se_3">
              <div className="_tit">구분</div>
            </div>
            <div className="_col _col_se_4">
              <div className="_tit">보험료 공제대상</div>
            </div>
            <div className="_col _col_se_3">
              <div className="_tit">공제한도</div>
            </div>
            <div className="_col _col_se_3">
              <div className="_tit">공제대상금액</div>
            </div>
            <div className="_col _col_se_3">
              <div className="_tit">세액공제</div>
            </div>
          </div>
        </div>

        <div className="_content">
          <div className="_row">
            <div className="_col _col_se_3">
              <div className="_cont">보장성보험료</div>
            </div>
            <div className="_col _col_se_4">
              <div className="_cont">
                기본공제대상자를 피보험자로 하는 생명보험, 상해보험, 손해보험, 각종 공제, 주택
                임차보증금 반환 보증보험
              </div>
            </div>
            <div className="_col _col_se_3">
              <div className="_cont">
                보험료의 합계액
                <br />
                기준 연 100만원
              </div>
            </div>
            <div className="_col _col_se_3">
              <div className="_cont">
                지급금액과 100만원 중 <br />
                적은 금액
              </div>
            </div>
            <div className="_col _col_se_3">
              <div className="_cont">공제대상금액의 12%</div>
            </div>
          </div>
          <div className="_row">
            <div className="_col _col_se_3">
              <div className="_cont">
                장애인전용
                <br />
                보장성보험료
              </div>
            </div>
            <div className="_col _col_se_4">
              <div className="_cont">
                기본공제대상자 중 장애인을 피보험자 또는 수익자로 하는 장애인전용보험으로서
                생명보험, 상해보험, 손해보험, 각종 공제, 주택 임차보증금 반환 보증보험
              </div>
            </div>
            <div className="_col _col_se_3">
              <div className="_cont">
                보험료의 합계액
                <br />
                기준 연 100만원
              </div>
            </div>
            <div className="_col _col_se_3">
              <div className="_cont">
                지급금액과 100만원 중<br />
                적은 금액
              </div>
            </div>
            <div className="_col _col_se_3">
              <div className="_cont"> 공제대상금액의 15%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyDescription;
